const supportBtn = {
  label: 'ADICIONAR'
};

export default supportBtn;
